import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function PaymentError(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "PaymentError", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.dark,
        d: "M33.414 9H7.344A4.345 4.345 0 0 0 3 13.345v14.483c0 2.4 1.945 4.344 4.345 4.344h26.069c2.4 0 4.345-1.945 4.345-4.344V13.345c0-2.4-1.946-4.345-4.345-4.345Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: theme.vars.palette.primary.light, d: "M37.759 13.345H3v4.345h34.759v-4.345Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.light,
        d: "M14.587 27.103H7.345a.724.724 0 0 1 0-1.448h7.242a.724.724 0 1 1 0 1.448Zm5.793 0h-2.897a.724.724 0 1 1 0-1.448h2.897a.724.724 0 1 1 0 1.448Zm-2.897-2.896H7.345a.724.724 0 0 1 0-1.449h10.138a.724.724 0 0 1 0 1.449Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: theme.vars.palette.secondary.main, d: "M35.5 39a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19Z" }),
    /* @__PURE__ */ jsx(
      "rect",
      {
        width: "3",
        height: "9",
        x: "37",
        y: "32",
        fill: theme.vars.palette.primary.dark,
        rx: "1.5",
        transform: "rotate(-180 37 32)"
      }
    ),
    /* @__PURE__ */ jsx("circle", { cx: "35.5", cy: "34.5", r: "1.5", fill: theme.vars.palette.primary.dark, transform: "rotate(-180 35.5 34.5)" })
  ] });
}
PaymentError.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "PaymentError"
};
validateTidalLicense();
export {
  PaymentError
};
//# sourceMappingURL=PaymentError.js.map
